import _ from './LodashImports';

const groupByBackendCategoryId = ({ products, filterOptions }) => {
  if (!Array.isArray(products)) {
    return [];
  }
  const groupedProducts = products.reduce((acc, variant) => {
    const backendCategoryId = _.get(variant, 'backendCategoryId', '');
    const variantsByGroup = _.get(acc, backendCategoryId, []);
    variantsByGroup.push(variant);
    acc[backendCategoryId] = variantsByGroup;
    return acc;
  }, {});
  const maxGroups = _.get(filterOptions, 'maxGroups');
  const podsByGroup = _.get(filterOptions, 'podsByGroup');
  const selectedVariants = Object.values(groupedProducts)
    .slice(0, maxGroups)
    .flatMap((variants) => variants.slice(0, podsByGroup));
  const minPods = _.get(filterOptions, 'minPods');
  if (!minPods) {
    return selectedVariants;
  }
  if (selectedVariants.length >= minPods) {
    return selectedVariants;
  }
  return [];
};

export { groupByBackendCategoryId };
